;(function($, undefined){

    var rnn = window.rnn;
    var isIconHovered;

    function eventIsOver (event, o) {
        if ((!o) || o==null) return false;
        var pos = o.offset();
        var ex = event.pageX;
        var ey = event.pageY;

        if($(o).hasClass('small-profile-pic') || $(o).parent().prev().hasClass('bottomLoad')){
            if (ex > pos.left
                && ex < pos.left+o.outerWidth()
                && ey > pos.top+o.outerHeight() - 15) {
                return true;
            }
        }else{
            if (ex > pos.left
                && ex < pos.left+o.outerWidth()
                && ey < pos.top+o.outerHeight()) {
                return true;
            }
        }
        return false;
    };

    $.fn.loadsBeyondTop = function(){
        var current_window = $(window),
            margin = 190,
            viewport_top = current_window.scrollTop(),
            bounds = this.offset();

        if(bounds.top < viewport_top + margin){
            return false;
        }else{
            return true;
        }
    };

    function findTagWidget(tag){
        var $el = $(tag),
            $classes = $el.attr('class'),
            classSplit = $classes.split('tag-'),
            picID = classSplit[1],
            $widget = $('.follow-tags .hidden-tag-' + picID);

        return $widget;
    }

    function findProfileWidget(profile){
        var $el = $(profile),
            $classes = $el.attr('class'),
            classSplit = $classes.split('small-img-'),
            picID = classSplit[1],
            $widget = $('.follow-wrapper.profile-' + picID);

        return $widget;
    }

    function checkTagPosition(tag){
        // by default, the widget will pop above the tags on the story.
        // however, if the tags are too high on the screen, we want them to appear below
        // the tags so the widget is not half off the screen.

        var canWidgetLoadAbove = $(tag).loadsBeyondTop();
        if(!canWidgetLoadAbove){
            var pushTop = $(tag).offset().top - $(tag).parent().offset().top - $(tag).parent().scrollTop() + 35;
            $('.newsEntryBody .follow-tags').css('top', pushTop + 'px');
            // inversed
            $('.newsEntryBody .follow-tags').addClass('bottomLoad');
        }else{
            $('.newsEntryBody .follow-tags').css('top', '-110px');
            $('.newsEntryBody .follow-tags').removeClass('bottomLoad');
        }
    }

    function displayWidget(el){
        var $el = $(el),
            $classes = $el.attr('class'),
            classSplit = $classes.split('small-img-'),
            picID = classSplit[1],
            $widget = $('.follow-wrapper.profile-' + picID);

        $widget.fadeIn('fast', function() {
            // Animation complete.
            $(this).removeClass('hidden').addClass('showing');
        });
    }


    function displayTopicWidget(el){

        var $widget = findTagWidget(el);

        $widget.fadeIn('fast', function() {
            // Animation complete.
            $(this).removeClass('hidden').addClass('showing');
        });
    }

    function initfollowWidget() {

        // for profile
        $('.small-profile-container .small-profile-pic').on("mouseenter", function() {
            displayWidget(this);
            $(".follow-wrapper").one("mouseleave", function(e) {
                $(this).hide();
            });
        });
        $('.small-profile-container .small-profile-pic').on("mouseleave", function(e) {
            if (eventIsOver(e, $(this)) === false) {
                $('.follow-wrapper').hide();
            }
        });

        // for tag
        $('.newsEntry p.tags a').on("mouseenter", function() {
            checkTagPosition(this);
            displayTopicWidget(this);
            $(".follow-wrapper").one("mouseleave", function(e) {
                $(this).hide();
            });
        });
        $('.newsEntry p.tags a').on("mouseleave", function(e) {
            if (eventIsOver(e, $(this)) === false) {
                $('.follow-wrapper').hide();
            }
        });
    }

    rnn.modules.register('followWidget', {
        init: initfollowWidget
    });

})(jQuery);
